import { createAction } from '@reduxjs/toolkit';
import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TSiteMetaClientState } from '../libs/store';

const LOAD_DUNGEON_ENCOUNTERS = 'SITE_META/LOAD_DUNGEON_ENCOUNTERS';
const UPDATE_DUNGEON_ENCOUNTERS = 'SITE_META/UPDATE_DUNGEON_ENCOUNTERS';

const loadDungeonEncounters = createAction<void>(LOAD_DUNGEON_ENCOUNTERS);
const updateDungeonEncounters =
  createAction<Partial<TSiteMetaClientState['dungeonEncounters']>>(UPDATE_DUNGEON_ENCOUNTERS);

export default function siteMeta(state: any = {}, action: TAction<any>): Partial<TSiteMetaClientState> {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return state; // keep the initial state that was loaded
    }
    case UPDATE_DUNGEON_ENCOUNTERS: {
      return {
        ...state,
        dungeonEncounters: {
          ...state.dungeonEncounters,
          ...action.payload
        }
      };
    }
    default:
      return state;
  }
}

export const siteMetaActions = {
  loadDungeonEncounters,
  updateDungeonEncounters
};

export const siteMetaActionTypes = {
  LOAD_DUNGEON_ENCOUNTERS,
  UPDATE_DUNGEON_ENCOUNTERS
};
